import { useEffect, useState } from 'react'
import api from '../services/api'

// Seguro de Vida (TMOTCA4: vigência/valores no cadmot + histórico frota.motse2)
// e Beneficiários (TMOTCA5, frota.motse1). Linhas numeradas sozinhas; excluir não pode.

interface Hist { lin: number; ds: string }
interface Benef { lan: number; nom: string; dna: string; par: string; doc: string }

const fmtNum = (v: any) => Number(v || 0).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
const fmtData = (iso: string) => (iso ? iso.split('-').reverse().join('/') : '')
const largura = (max: number) => Math.max(56, max * 9 + 28)
const LINHA: React.CSSProperties = { display: 'flex', flexWrap: 'wrap', gap: '0.75rem 0.9rem', alignItems: 'flex-end' }
const th: React.CSSProperties = { textAlign: 'left', padding: '0.4rem 0.6rem', fontSize: '0.72rem' }
const td: React.CSSProperties = { padding: '0.3rem 0.5rem', fontSize: '0.82rem' }

function Cabecalho({ titulo, codigo, onClose }: { titulo: string; codigo: string; onClose: () => void }) {
  return (
    <div className="modal-header" style={{ gap: '1rem' }}>
      <div style={{ minWidth: 0 }}><h2>{titulo}</h2></div>
      <div style={{ display: 'flex', alignItems: 'center', gap: '0.75rem', flexShrink: 0, marginLeft: 'auto' }}>
        <span style={{ fontSize: '0.78rem', fontWeight: 700, color: 'rgba(219,234,254,0.8)' }}>{codigo}</span>
        <button className="modal-fechar" onClick={onClose}>✕</button>
      </div>
    </div>
  )
}

const campo = (w: number, label: string, conteudo: React.ReactNode) => (
  <div className="field-cad" style={{ flex: `0 0 ${w}px` }}>
    <label style={{ whiteSpace: 'nowrap' }}>{label}</label>
    {conteudo}
  </div>
)

function BeneficiariosModal({ motcod, motnome, onClose }: { motcod: string; motnome: string; onClose: () => void }) {
  const VAZIO: Benef = { lan: 0, nom: '', dna: '', par: '', doc: '' }
  const [lista, setLista] = useState<Benef[] | null>(null)
  const [f, setF] = useState<Benef>(VAZIO)
  const [erro, setErro] = useState('')
  const [aviso, setAviso] = useState('')
  const [salvando, setSalvando] = useState(false)

  async function carregar(manterLan?: number) {
    const r = await api.get(`/funcionarios/${encodeURIComponent(motcod)}/beneficiarios`)
    setLista(r.data)
    const alvo = r.data.find((x: Benef) => x.lan === manterLan)
    setF(alvo ?? (manterLan === undefined && r.data[0]) ?? VAZIO)
  }

  useEffect(() => {
    carregar().catch(() => setErro('Não foi possível carregar os beneficiários.'))
  }, [motcod])

  async function salvar() {
    setErro(''); setAviso('')
    if (!f.nom.trim()) return setErro('Informe o nome do beneficiário.')
    setSalvando(true)
    try {
      const r = await api.put(`/funcionarios/${encodeURIComponent(motcod)}/beneficiarios`, f)
      await carregar(r.data.lan)
      setAviso(r.data?.semAlteracao ? 'Nenhuma alteração para salvar.' : 'Beneficiário salvo.')
    } catch (e: any) {
      setErro(e?.response?.data?.error || 'Erro ao salvar o beneficiário.')
    } finally {
      setSalvando(false)
    }
  }

  const set = (c: keyof Benef, v: string) => setF(p => ({ ...p, [c]: v }))
  const txt = (c: keyof Benef, label: string, max: number) =>
    campo(Math.max(largura(max), label.length * 7 + 10), label,
      <input value={String(f[c] ?? '')} maxLength={max} style={{ width: '100%', boxSizing: 'border-box' }}
        onChange={e => set(c, e.target.value.toUpperCase())} />)

  return (
    <div className="modal-overlay" style={{ zIndex: 1400 }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" style={{ maxWidth: 700, maxHeight: '92vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <Cabecalho titulo={`Beneficiários do Seguro — ${motcod} · ${motnome}`} codigo="TMOTCA5" onClose={onClose} />
        <div className="modal-corpo">
          {!lista ? (
            <p style={{ color: erro ? '#dc2626' : '#6b7280' }}>{erro || 'Carregando...'}</p>
          ) : (
            <>
              <div style={{ maxHeight: 200, overflowY: 'auto', border: '1px solid #e5e7eb', borderRadius: 8 }}>
                <table className="table" style={{ width: '100%', margin: 0 }}>
                  <thead>
                    <tr><th style={{ ...th, width: 50 }}>Nº</th><th style={th}>Nome</th><th style={th}>Dt Nasc.</th><th style={th}>Parentesco</th><th style={th}>Documento</th></tr>
                  </thead>
                  <tbody>
                    {lista.length === 0 && (
                      <tr><td colSpan={5} style={{ ...td, textAlign: 'center', color: '#6b7280', padding: '1rem' }}>Nenhum beneficiário cadastrado.</td></tr>
                    )}
                    {lista.map(x => {
                      const ativo = x.lan === f.lan
                      return (
                        <tr key={x.lan} onClick={() => { setF(x); setErro(''); setAviso('') }}
                          style={{ cursor: 'pointer', background: ativo ? '#eef3fb' : undefined, fontWeight: ativo ? 600 : undefined }}>
                          <td style={td}>{x.lan}</td><td style={td}>{x.nom}</td><td style={td}>{fmtData(x.dna) || '—'}</td>
                          <td style={td}>{x.par || '—'}</td><td style={td}>{x.doc || '—'}</td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </div>
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '1rem 0 0.6rem' }}>
                <span style={{ fontSize: '0.72rem', fontWeight: 700, color: '#1a6ea8', textTransform: 'uppercase', letterSpacing: '0.06em' }}>
                  {f.lan ? `Beneficiário ${f.lan}` : 'Novo beneficiário'}
                </span>
                {!!f.lan && <button className="btn btn-secondary btn-sm" onClick={() => { setF(VAZIO); setErro(''); setAviso('') }}>+ Novo beneficiário</button>}
              </div>
              <div style={LINHA}>
                {txt('nom', 'Nome *', 30)}
                {campo(140, 'Dt Nascimento',
                  <input type="date" value={f.dna} style={{ width: '100%', boxSizing: 'border-box' }} onChange={e => set('dna', e.target.value)} />)}
              </div>
              <div style={{ ...LINHA, marginTop: '0.75rem' }}>
                {txt('par', 'Parentesco', 20)}
                {txt('doc', 'Documento', 20)}
              </div>
            </>
          )}
          {lista && erro && <p style={{ color: '#dc2626', fontSize: '0.82rem', margin: '1rem 0 0' }}>{erro}</p>}
          {aviso && <p style={{ color: '#16a34a', fontSize: '0.82rem', margin: '1rem 0 0' }}>{aviso}</p>}
        </div>
        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Fechar</button>
          <button className="btn btn-orange" onClick={salvar} disabled={salvando || !lista}>{salvando ? 'Salvando...' : 'Salvar'}</button>
        </div>
      </div>
    </div>
  )
}

export default function FuncionarioSeguroModal({ motcod, motnome, onClose }: { motcod: string; motnome: string; onClose: () => void }) {
  const [f, setF] = useState<{ motsegini: string; motsegfim: string; vlc: string; vlp: string } | null>(null)
  const [hist, setHist] = useState<Hist[]>([])
  const [beneficiarios, setBeneficiarios] = useState(false)
  const [erro, setErro] = useState('')
  const [aviso, setAviso] = useState('')
  const [salvando, setSalvando] = useState(false)

  async function carregar() {
    const r = await api.get(`/funcionarios/${encodeURIComponent(motcod)}/seguro`)
    setF({ motsegini: r.data.motsegini, motsegfim: r.data.motsegfim, vlc: fmtNum(r.data.vlc), vlp: fmtNum(r.data.vlp) })
    setHist(r.data.historico)
  }

  useEffect(() => {
    carregar().catch(() => setErro('Não foi possível carregar o seguro de vida.'))
  }, [motcod])

  async function salvar() {
    setErro(''); setAviso('')
    setSalvando(true)
    try {
      const r = await api.put(`/funcionarios/${encodeURIComponent(motcod)}/seguro`, { ...f, historico: hist })
      await carregar()
      setAviso(r.data?.semAlteracao ? 'Nenhuma alteração para salvar.' : 'Seguro de vida salvo.')
    } catch (e: any) {
      setErro(e?.response?.data?.error || 'Erro ao salvar o seguro de vida.')
    } finally {
      setSalvando(false)
    }
  }

  const set = (c: string, v: string) => setF(p => ({ ...p!, [c]: v }))
  const valor = (c: 'vlc' | 'vlp', label: string) =>
    campo(Math.max(largura(10), label.length * 7 + 10), label,
      <input value={f![c]} inputMode="decimal" maxLength={10} style={{ width: '100%', boxSizing: 'border-box', textAlign: 'right' }}
        onChange={e => set(c, e.target.value.replace(/[^\d.,]/g, ''))} />)

  return (
    <div className="modal-overlay" style={{ zIndex: 1300 }} onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal-box" style={{ maxWidth: 700, maxHeight: '92vh', display: 'flex', flexDirection: 'column' }} onClick={e => e.stopPropagation()}>
        <Cabecalho titulo={`Seguro de Vida — ${motcod} · ${motnome}`} codigo="TMOTCA4" onClose={onClose} />

        <div className="modal-corpo">
          {!f ? (
            <p style={{ color: erro ? '#dc2626' : '#6b7280' }}>{erro || 'Carregando...'}</p>
          ) : (
            <>
              <div style={LINHA}>
                {campo(140, 'Vigência — início',
                  <input type="date" value={f.motsegini} style={{ width: '100%', boxSizing: 'border-box' }} onChange={e => set('motsegini', e.target.value)} />)}
                {campo(140, 'Vigência — fim',
                  <input type="date" value={f.motsegfim} min={f.motsegini || undefined} style={{ width: '100%', boxSizing: 'border-box' }} onChange={e => set('motsegfim', e.target.value)} />)}
                {valor('vlc', 'Valor Cobertura')}
                {valor('vlp', 'Valor Prêmio')}
                <button className="btn btn-secondary btn-sm" style={{ marginLeft: 'auto' }} onClick={() => setBeneficiarios(true)} data-livre>Beneficiários</button>
              </div>

              <div style={{ fontSize: '0.72rem', fontWeight: 700, color: '#1a6ea8', textTransform: 'uppercase', letterSpacing: '0.06em', margin: '1.1rem 0 0.5rem' }}>
                Histórico
              </div>
              <table className="table" style={{ width: '100%' }}>
                <thead>
                  <tr><th style={{ ...th, width: 50 }}>Lin</th><th style={th}>Descrição</th></tr>
                </thead>
                <tbody>
                  {hist.length === 0 && (
                    <tr><td colSpan={2} style={{ ...td, textAlign: 'center', color: '#6b7280', padding: '1rem' }}>Nenhum histórico lançado.</td></tr>
                  )}
                  {hist.map((h, i) => (
                    <tr key={h.lin || `nova-${i}`}>
                      <td style={{ ...td, color: '#6b7280' }}>{h.lin || '—'}</td>
                      <td style={td}>
                        <input value={h.ds} maxLength={50} style={{ width: largura(50), maxWidth: '100%', boxSizing: 'border-box', padding: '0.35rem 0.5rem', fontSize: '0.82rem' }}
                          onChange={e => setHist(hs => hs.map((x, j) => (j === i ? { ...x, ds: e.target.value.toUpperCase() } : x)))} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              <button className="btn btn-secondary btn-sm" style={{ marginTop: '0.75rem' }} onClick={() => setHist(hs => [...hs, { lin: 0, ds: '' }])}>
                + Nova linha
              </button>
            </>
          )}

          {f && erro && <p style={{ color: '#dc2626', fontSize: '0.82rem', margin: '1rem 0 0' }}>{erro}</p>}
          {aviso && <p style={{ color: '#16a34a', fontSize: '0.82rem', margin: '1rem 0 0' }}>{aviso}</p>}
        </div>

        <div className="modal-footer">
          <button className="btn btn-secondary" onClick={onClose}>Fechar</button>
          <button className="btn btn-orange" onClick={salvar} disabled={salvando || !f}>{salvando ? 'Salvando...' : 'Salvar'}</button>
        </div>
      </div>

      {beneficiarios && <BeneficiariosModal motcod={motcod} motnome={motnome} onClose={() => setBeneficiarios(false)} />}
    </div>
  )
}
